/**
 * Video Editor
 * Handles configuration for video display controls
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

/**
 * Render function for video control
 */
function renderVideoEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Control Configuration</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Video URL
          <input
            type="text"
            value={(control.config?.src as string) || ''}
            onChange={(e) => onConfigChange('src', e.target.value || undefined)}
            className="af-properties-tab__input"
            placeholder="https://..."
          />
        </label>
      </div>
      <div className="af-properties-tab__checkbox-group">
        <label className="af-properties-tab__checkbox-label">
          <input
            type="checkbox"
            checked={(control.config?.controls as boolean) !== false}
            onChange={(e) => onConfigChange('controls', e.target.checked)}
          />
          Show Controls
        </label>
      </div>
      <div className="af-properties-tab__checkbox-group">
        <label className="af-properties-tab__checkbox-label">
          <input
            type="checkbox"
            checked={(control.config?.autoPlay as boolean) ?? false}
            onChange={(e) => onConfigChange('autoPlay', e.target.checked)}
          />
          Auto Play
        </label>
      </div>
      <div className="af-properties-tab__checkbox-group">
        <label className="af-properties-tab__checkbox-label">
          <input
            type="checkbox"
            checked={(control.config?.loop as boolean) ?? false}
            onChange={(e) => onConfigChange('loop', e.target.checked)}
          />
          Loop
        </label>
      </div>
    </div>
  );
}

/**
 * VideoEditor - Handles video control configuration
 */
export const VideoEditor: PropertyEditor = {
  type: 'video',
  label: 'Video',
  description: 'Configure video URL and playback options',
  render: renderVideoEditor,
};
